import React, { useState, useEffect } from 'react';
import { compatAPI } from '../../utils/api';

export default function OuiAnalysisPage() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        compatAPI.getOuiFailures()
            .then(res => {
                // Backend returns {data: [...]}; tolerate other shapes too.
                const d = res.data;
                const rows = Array.isArray(d) ? d
                           : Array.isArray(d?.failures) ? d.failures
                           : Array.isArray(d?.data)     ? d.data
                           : [];
                setData(rows);
            })
            .catch(err => console.error('OUI failures error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">OUI Analysis</h2>
            <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">OUI Failure Rates</h3>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">OUI Prefix</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Manufacturer</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Sessions</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Failures</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Failure Rate</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {data.map((row, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-900">{row.oui_prefix || row.sink_mac_oui || '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{row.manufacturer || row.sink_oui_vendor || 'Unknown'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{row.total_sessions ?? row.total_attempts ?? 0}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{row.failures ?? 0}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {row.failure_rate != null
                                            ? Math.round(Number(row.failure_rate) * 100) / 100
                                            : row.error_rate != null
                                                ? Math.round(Number(row.error_rate) * 1000) / 10
                                                : 0}%
                                    </td>
                                </tr>
                            ))}
                            {data.length === 0 && (
                                <tr><td colSpan="5" className="px-6 py-6 text-sm text-gray-400 text-center">No OUI failure data</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
